
export default function CoreStrategies() {
  const strategies = [
    {
      number: '01',
      icon: 'ri-lightbulb-line',
      title: 'Sáng Lập Hệ Thống & Tầm Nhìn',
      description: 'Xây dựng hệ sinh thái du lịch Mỹ bền vững với tầm nhìn dài hạn, định hướng rõ ràng và chiến lược phát triển toàn diện.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      number: '02',
      icon: 'ri-book-open-line',
      title: 'Đào Tạo – Coaching – Training',
      description: 'Chương trình đào tạo liên tục, coaching 1-1, training theo nhóm giúp đại lý nắm vững kỹ năng bán tour Mỹ chuyên nghiệp.',
      color: 'from-green-500 to-green-600'
    },
    {
      number: '03',
      icon: 'ri-rocket-line',
      title: 'Vũ Khí Marketing Mạnh Nhất',
      description: 'Bộ sales kit, hình ảnh 4K, video chuyên nghiệp, nội dung viral - công cụ marketing vượt trội so với thị trường.',
      color: 'from-purple-500 to-purple-600'
    },
    {
      number: '04',
      icon: 'ri-hand-heart-line',
      title: 'Chăm Sóc & Đồng Hành',
      description: 'Hỗ trợ từng đại lý 24/7, tư vấn chiến lược, giải đáp thắc mắc, cùng nhau vượt qua mọi thử thách.',
      color: 'from-orange-500 to-orange-600'
    },
    {
      number: '05',
      icon: 'ri-trophy-line',
      title: 'Nâng Cấp & Vinh Danh',
      description: 'Hệ thống cấp bậc rõ ràng, chính sách thưởng hấp dẫn, vinh danh đại lý xuất sắc, tạo động lực phát triển.',
      color: 'from-red-500 to-red-600'
    }
  ];

  return (
    <section id="strategies" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            5 Chiến Lược Cốt Lõi
          </h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-400 mx-auto mb-6 sm:mb-8"></div>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto px-4">
            Nền tảng vững chắc giúp Liên Minh Du Lịch Mỹ phát triển bền vững và dẫn đầu thị trường
          </p>
        </div>

        <div className="space-y-6 sm:space-y-8">
          {strategies.map((strategy, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="flex flex-col md:flex-row items-center">
                <div className={`w-full md:w-1/3 bg-gradient-to-br ${strategy.color} p-8 sm:p-10 md:p-12 text-white flex flex-col items-center justify-center`}>
                  <div className="text-5xl sm:text-6xl font-bold opacity-30 mb-3 sm:mb-4">{strategy.number}</div>
                  <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-white/20 rounded-full mb-3 sm:mb-4">
                    <i className={`${strategy.icon} text-4xl sm:text-5xl`}></i>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-center">{strategy.title}</h3>
                </div>
                
                <div className="w-full md:w-2/3 p-6 sm:p-8 md:p-12">
                  <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">{strategy.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 sm:mt-16 px-4">
          <a 
            href="#partnership"
            className="inline-block w-full sm:w-auto px-6 sm:px-8 md:px-10 py-4 sm:py-5 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm sm:text-base md:text-lg font-bold rounded-full hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Nhận Tài Liệu Chiến Lược
          </a>
        </div>
      </div>
    </section>
  );
}